import Vue from 'vue'

import './styles/quasar.sass'
import iconSet from 'quasar/icon-set/fontawesome-v5.js'
import '@quasar/extras/material-icons/material-icons.css'
import '@quasar/extras/fontawesome-v5/fontawesome-v5.css'
// import '@quasar/extras/fontawesome-v4/fontawesome-v5.css'

import { Quasar } from 'quasar'
import { Notify } from 'quasar'

Vue.use(Quasar, {
  config: { 
    
   },
  components: { /* not needed if importStrategy is not 'manual' */ },
  directives: { /* not needed if importStrategy is not 'manual' */ },
  iconSet: iconSet, 
  plugins: [ Notify],
  extras: ['font-awesome-v4.7.0'],
 })